import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import axios from "axios";
import * as render from "./render.js";
import { globalVars } from "../global/GlobalVars.js";

const RenderCustomElements = observer(({ type, ...props }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    //========================================================================
    // anzeigen von customTypes
    // IP-Adresse des Servers
    const url =
      window.location.port === "3000"
        ? `http://${window.location.hostname}:${globalVars.httpPort}/project/customElements/${type}.json`
        : `/project/customElements/${type}.json`;

    // Dynamisch importieren basierend auf customElement
    axios
      .get(url)
      .then((response) => {
        setData(response.data);
      })
      .catch((error) => {
        // console.error("Error loading the JSON:", error);
      });
  }, [type, globalVars.updateElementsTrigger]);

  if (!data) return <div></div>; // "Loading..."

  return (
    <div>
      {data.elements?.map((elementToRender, index) => (
        <div key={(index + 1) * (props.mapIndex + 1)}>
          {render.renderElement(
            elementToRender,
            props.scaleFactor,
            (index + 1) * (props.mapIndex + 1),
            props.xOffset,
            props.yOffset,
            props.interfaceProps,
          )}
        </div>
      ))}
    </div>
  );
});
export default RenderCustomElements;
